import { Box, Button, Divider, Typography } from "@mui/material";
import { FC } from "react";

import __ from "web/Layout/Translations";

import Dialog from "web/Components/mui/Dialog";

interface ISubscriptionCancelMUI {
  handleConfirmClose: () => void;
  handleCancelClose: () => void;
  showConfirmClose: boolean;
  isMobile: boolean;
}

const SubscriptionCancelMUI: FC<ISubscriptionCancelMUI> = ({
  handleConfirmClose,
  showConfirmClose,
  handleCancelClose,
  isMobile,
}) => {
  return (
    <Dialog
      open={showConfirmClose}
      onClose={handleCancelClose}
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: "512px",
        },
        ...(!isMobile && {
          ".MuiDialogContent-root, & .MuiDialogTitle-root": {
            p: 0,
          },
          ".MuiDialogTitle-root": {
            pb: 1,
          },
        }),
        ...(isMobile && {
          ".MuiPaper-root": {
            p: 3,
          },
          ".MuiDialogTitle-root": {
            pb: 1,
            mb: 0,
          },
          ".MuiDialogContent-root": {
            pb: 0,
          },
        }),
      }}
      title={__("Wyjdź z edycji danych")}
      noTitleDivider
    >
      <Typography>{__("Zmiany nie zostaną zapisane")}</Typography>
      <Divider sx={{ my: 2 }} />
      <Box display="flex" justifyContent="flex-end">
        <Button
          onClick={handleCancelClose}
          variant="outlined"
          color="primary"
          size="large"
          sx={{ mr: 1 }}
          fullWidth={isMobile}
        >
          {__("Kontynuuj edycję")}
        </Button>
        <Button
          onClick={handleConfirmClose}
          variant="contained"
          color="error"
          size="large"
        >
          {__("Wyjdź")}
        </Button>
      </Box>
    </Dialog>
  );
};

export default SubscriptionCancelMUI;
